<template>
  <div>
    <v-col v-if="searchBox" cols="12" id="searchBoxDiv">
      <SearchBox
        id="searchBox"
        @search="search = $event"
      />
    </v-col>
    <ListOneLItemsSelect
      :items="computedTabelasPreco"
      itemTitle="tabela_preco"
      :fullscreen="true"
      :searchBox="searchBox"
      @clicked="$emit('tabelaPrecoSelected', $event)"
    />
    <div class="my-3" id="listTabelasPrecoPagination">
      <v-pagination
        v-model="page"
        :length="totalPages"
        circle
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchBox from '@/components/shared/SearchBox';
import ListOneLItemsSelect from '@/components/shared/list/ListOneLItemsSelect';
import { convertStringToCompare } from '@/helpers';

export default {
  name: 'ListTabelasPrecoSelect',
  props: {
    searchBox: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    page: 1,
    order: 'id_tabela_preco',
    search: '',
  }),
  components: {
    SearchBox,
    ListOneLItemsSelect
  },
  computed: {
    ...mapGetters(['tabelasPreco']),
    computedTabelasPreco() {
      const start = (this.page - 1) * 10;
      const end = start + 10;
      let searchTerm = this.search || '';
      searchTerm = convertStringToCompare(searchTerm);
      return this.tabelasPreco
        .filter(tabelaPreco =>
          Object.keys(tabelaPreco)
            .some(key => convertStringToCompare(tabelaPreco[key]).includes(searchTerm || ''))
        )
        .slice(start, end)
        .sort((a, b) => a[this.order] > b[this.order] ? 1 : -1);
    },
    totalPages() {
      const total = this.tabelasPreco.length / 10;
      return total !== Infinity ? Math.ceil(total) : 0;
    }
  },
}
</script>

<style>

</style>